
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
} from '@mui/x-data-grid';
import Box from "@mui/material/Box"

import {
    Avatar,
    Tooltip
} from "@mui/material";

// App Imports
import {getContractStatsGuild} from "../../Contract/ContractClient";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeContractStats} from "./contractStatsSlice";
import {changeContractStatsControls} from "./contractStatsControlsSlice";


// main function
export default function GuildContractStatsGrid() {

    // ****************** BEGIN STATES ****************************

    const [guildContractStats, setGuildContractStats] = useState([]);
    const [gridVisible, setGridVisible] = React.useState(true);


    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorGridDisplay = useSelector((state) => state.contractStatsControlsSlc.value.gridDisplay);
    const selectorProductId = useSelector((state) => state.contractStatsSlc.value.productId);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const dispatchData = useDispatch();

    const selectorGridRefresh = useSelector(state => state.contractStatsControlsSlc.value.gridRefresh);

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************


    const fetchGuildContractStats = React.useCallback(() => {
        if (!selectorProductId) return Promise.resolve();

        return getContractStatsGuild(selectorProductId)

            .then(data => {
                console.log("selectorProductId: ", selectorProductId);
                console.log("guild stats data set:");
                console.log(data);
                setGuildContractStats(data);
            });
    }, [selectorProductId]);


    useEffect(() => {
        fetchGuildContractStats();
    }, [fetchGuildContractStats]);


    useEffect(() => {
        if (!selectorGridRefresh) return;
        console.log("fetch guild contract stats called in guild contract stats grid useEffect")
        fetchGuildContractStats().finally(() => {
            dispatchData(changeContractStatsControls({ gridRefresh: false }));
        });
    }, [selectorGridRefresh, fetchGuildContractStats, dispatchData]);

    //
    // const fetchGuildContractStats = () =>
    //     getContractStatsGuild(selectorProductId)

    //         .then(data => {
    //              console.log("selectorProductId: ", selectorProductId )
    //             console.log("guild stats data set:")
    //             console.log(data);
    //             setGuildContractStats(data);
    //         })
    // useEffect(() => {
    //     fetchGuildContractStats();
    // }, []);
    //
    // useEffect(() => {
    //     fetchGuildContractStats();
    //     dispatchData(changeContractStatsControls({gridRefresh: false}));
    // }, [useSelector((state) => state.contractStatsControlsSlc.value.gridRefresh)===true]);


    // ****************** END FETCH ****************************


    const renderGuildContractStats = guildContractStats => {
        if (guildContractStats.length <= 0) {
            return "No Data";
        }}


    // ****************** BEGIN CRUD ***********************************



    // ****************** END CRUD ***********************************



    // ****************** BEGIN DRILLDOWN ****************************

    const handleDrilldown = (selectSeriesContractStatId,selectSeriesContractStatMcode, selectSeriesContractStatName, selectSeriesContractStatDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        // dispatchData(changeSeriesContractStat({id: selectSeriesContractStatId, mcode: selectSeriesContractStatMcode, name: selectSeriesContractStatName, description: selectSeriesContractStatDescription }));
    }

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (seriesContractStats) => {

        console.log('Stats data from clicked row');
        console.log(seriesContractStats);
        dispatchData(changeContractStats({seriesId: seriesContractStats.seriesId,
            seasonId: seriesContractStats.seasonId, productId: seriesContractStats.productId}));
        dispatchData(changeContractStatsControls({gridDisplay: "GuildFullScreen"}));
    };




    // ****************** BEGIN COLUMNS ****************************

    const columns = fetchGuildContractStats => [

        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'seriesTitle',
            headerName: 'Series Title',
            description: '',
            sortable: true,
            editable: true,
            hide: true,
            width: 300,
        },
        {
            field: 'seriesId',
            headerName: 'Series ID',
            description: '',
            sortable: false,
            editable: false,
            hide: true,
            width: 80,
        },
        {
            field: 'seasonNumber',
            headerName: 'Season #',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            width: 80,
        },
        {
            field: 'seasonName',
            headerName: 'Season Name',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            width: 200,
        },
        {
            field: 'seasonId',
            headerName: 'Season ID',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            width: 80,
        },

        {
            field: 'productId',
            headerName: 'Product ID',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            width: 100,
        },
        {
            field: 'propertyTitle',
            headerName: 'Property Title',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            width: 200,
        },
        {
            field: 'episodedName',
            headerName: 'Episode Name',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            width: 200,
        },
        {
            field: 'photoStartDate',
            headerName: 'Photo Start Date',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            width: 100,
        },
        {
            field: 'contractTypeName',
            headerName: 'Contract Type',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            width: 150,
        },
        {
            field: 'templateGuildCombo',
            headerName: 'Template / Guild',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            width: 150,
        },
        {
            field: 'guild',
            headerName: 'Guild',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            width: 100,
        },
        {
            field: 'approvedCount',
            headerName: 'Approved',
            width: 100,
            headerAlign: 'center',
            renderCell: (guildContractStats) => {
                const count = guildContractStats.row.approvedCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of approved contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'unapprovedCount',
            headerName: 'Unapproved',
            width: 100,
            headerAlign: 'center',
            renderCell: (guildContractStats) => {
                const count = guildContractStats.row.unapprovedCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit
                const avatarColor = count === 0 ? "rgb(30,144,255)" : "warning.main"
                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of unapproved contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                // backgroundColor: "rgb(30,144,255)",
                                backgroundColor: avatarColor,
                                // "warning.main",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },


    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN TOOLBAR ****************************



    // ****************** END TOOLBAR ****************************

    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            { selectorGridDisplay === "Guild" && <Box sx={{height: 70, pt: 1, pl: 3}}>
                <h3>Guild Contract Statistics</h3>
            </Box>}
            {selectorGridDisplay !== "Guild" &&
                <Box sx={{height: 20, pt: 1, pl: 3}}>
                {/*<h3>Hi there</h3>*/}
                </Box>}
            {/*<Box sx={{height: 70, pt: 1, pl: 3}}>*/}
            {/*    <h3>Guild Contract Statistics</h3>*/}
            {/*</Box>*/}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                style={{cursor: 'pointer'}}
                aria-label={"GuildContractStats"}
                rows={guildContractStats}
                disableDensitySelector={true}
                disableColumnSelector={true}
                // columns={columns(fetchGuildContractStats)}
                columns={columns()}
                // onRowClick = {(guildContractStats)=>handleClickedRow(guildContractStats.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                // I just added back in rowKey from the AmigosCode example, which should define seriesContractStat and seriesContractStat.id
                // this is needed for identifying which seriesContractStat to delete or edit
                rowKey={seriesContractStat => seriesContractStat.id}
                components={{
                    // Toolbar: CustomToolbar,
                    Footer: CustomFooter,
                }}
            />}
            {/*<div>*/}
            {/*</div>*/}
        </div>
    );

    // ****************** END RETURN ****************************

}

